// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@font-face{\n    font-family: Acme;\n    src: url(\"/assets/font/Acme/Acme-Regular.ttf\") format(\"truetype\");\n}", "",{"version":3,"sources":["webpack://src/assets/font/Acme/acme.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iEAAiE;AACrE","sourcesContent":["@font-face{\n    font-family: Acme;\n    src: url(\"/assets/font/Acme/Acme-Regular.ttf\") format(\"truetype\");\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
